// Messages a customer sent from the returns site's window-closed contact form
// (Portal-BE returnContacts.js): what it's about, their words, their photos,
// and where it went (a Gorgias ticket on production, the support inbox by
// email elsewhere). Staff reply from the inbox; this is the record.
import { ExternalLink, MessageSquare } from "lucide-react";
import { useTranslation } from "../../i18n";
import { ReturnContact } from "../../api/returns";
import { PhotoStrip } from "./ReturnPhotos";

const DELIVERY_PILL: Record<ReturnContact["delivery"], string> = { gorgias: "green", email: "green", pending: "amber", failed: "orange" };

export const ContactList = ({ contacts, showOrder = false }: { contacts: ReturnContact[]; showOrder?: boolean }) => {
    const { t, language } = useTranslation();
    if (contacts.length === 0) return null;
    const when = new Intl.DateTimeFormat(language === "pl" ? "pl-PL" : "en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
    return (
        <div className="rt-contacts" data-testid="rt-contacts">
            <h4 className="rt-contacts-title"><MessageSquare size={14} /> {t("rt_contacts_title")}</h4>
            <p className="rt-muted rt-small">{t("rt_contacts_hint")}</p>
            {contacts.map((c) => (
                <div key={c.id} className="rt-contact">
                    <span className="rt-contact-head">
                        <strong>{t(`rt_contact_reason_${c.reason}`)}</strong>
                        <span className={`rt-pill rt-pill--${DELIVERY_PILL[c.delivery] ?? "grey"}`}>{t(`rt_contact_delivery_${c.delivery}`)}</span>
                        {c.gorgias_url && (
                            <a className="rt-ref-link" href={c.gorgias_url} target="_blank" rel="noopener noreferrer">
                                {t("rt_contact_view_gorgias")} <ExternalLink size={12} />
                            </a>
                        )}
                    </span>
                    <span className="rt-muted rt-small">
                        {when.format(new Date(c.created_at))} · {c.name ? `${c.name} · ` : ""}{c.email}
                        {showOrder ? ` · ${t("rt_contact_order", { ref: c.order_reference })}` : ""}
                    </span>
                    <p className="rt-contact-msg">{c.message}</p>
                    <PhotoStrip photos={c.photo_ids.map((photo_id) => ({ photo_id }))} />
                </div>
            ))}
        </div>
    );
};
